import type { AgentIconType } from './agentIconType.ts';

export type AgentBrand = {
	readonly name: string;
	readonly agentIcon: AgentIconType;
};

const AGENT_BRANDS: readonly AgentBrand[] = [
	{ name: 'Claude Code', agentIcon: 'claude' },
	{ name: 'Claude', agentIcon: 'claude' },
	{ name: 'Codex', agentIcon: 'codex' },
	{ name: 'Rovo', agentIcon: 'rovo' },
	{ name: 'Cursor', agentIcon: 'cursor' },
	{ name: 'ChatGPT', agentIcon: 'chatgpt' },
	{ name: 'Dia', agentIcon: 'dia' },
];

/**
 * Recognizes a brand's exact name or per-integration name, such as
 * "Claude Code (atlassian-mcp)". The " (" separator avoids matching unrelated
 * names such as "Claudette". Unknown agents retain their own name and avatar.
 * Consumers remain responsible for grouping and feature-gated display policies.
 */
export const getAgentBrand = (displayName: string): AgentBrand | undefined =>
	AGENT_BRANDS.find(({ name }) => displayName === name || displayName.startsWith(`${name} (`));
